import React, { useState } from "react";
import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from "@react-google-maps/api";

import img from "../../assets/images/brewhouse_ascenda.png";

const Map = (props) => {
  const [infoOpen, setInfoOpen] = useState(false);

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: props.apiKey
  })

  const containerStyle = {
    width: '100%',
    height: '100%'
  };

  const center = {
    lat: 57.700574,
    lng: 11.99368
  };

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={17}
    >
      <Marker position={{ lat: 57.70024, lng: 11.99368 }} onClick={() => setInfoOpen(true)} />
      {infoOpen && (
        <InfoWindow onCloseClick={() => setInfoOpen(false)} position={{ lat: 57.70024, lng: 11.99368 }}>
          <div style={{ color: "black" }}>
            <h2>Ascenda AB</h2>
            <img alt="ascenda office" src={img} style={{ height: "100%", width: "100%" }} />
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  ) : <></>
};

export default React.memo(Map);
